import { render } from "./record.vue?vue&type=template&id=186aba46&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"

import "./record.vue?vue&type=style&index=0&id=186aba46&scoped=true&lang=css"
import "./record.vue?vue&type=style&index=1&id=186aba46&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-186aba46"

export default script